import Image from "@components/Image";
import cx from "classnames";
import styles from "./Explanation.module.scss";
import { usePageContext } from "@providers/PageProvider";
import { brandStoryPage } from "@utils/helper";
import _ from "lodash";

export default function Explanation() {
  const { pageData } = usePageContext();
  const explanation: any = brandStoryPage.formatExplanation(pageData);
  return (
    <div className={cx(styles.section)}>
      <div className={cx(styles.wrapper)}>
        <div className={cx(styles.textContent)}>
          {_.get(explanation, "content", "")}
        </div>
        <Image
          wrapperProps={{ className: cx(styles.image) }}
          src={_.get(explanation, "image.src", {}) ?? "/brand-story/2.jpg"}
          alt={_.get(explanation, "image.alt", {}) ?? "brand-story-image-2"}
          layout="fill"
          objectFit="cover"
        />
        <div className={cx(styles.imageBackgroundWrapper)}>
          <Image
            speed={0}
            wrapperProps={{ className: cx(styles.imageBg) }}
            src={
              _.get(explanation, "background.src", {}) ?? "/brand-story/bg2.svg"
            }
            alt={
              _.get(explanation, "background.alt", {}) ??
              "brand-story-image-bg2"
            }
            layout="fill"
            objectFit="cover"
          />
        </div>
      </div>
    </div>
  );
}
